import Vue from 'vue'
import Vuex from 'vuex'
// ----- Start import modules ------ //
// Authentication login/logout/register
import auth from './auth'
import AirlineModule from './airline'
import InvoicesModule from './invoices'
import DebtorsModule from './debtors'
import CreditorsModule from './creditors'
import ConfigurationsModule from "./configuration";
import InvoiceTemplateModule from './invoiceTemplate';
// ----- End import modules ------ //

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth,
    AirlineModule,
    InvoicesModule,
    DebtorsModule,
    CreditorsModule,
    ConfigurationsModule,
    InvoiceTemplateModule,
  }
})
